import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder.svg'


const _hoisted_1 = { class: "content-buttons" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "next-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button button-prev",
      onClick: $setup.onSelectPrev
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        class: "reverse",
        src: _imports_0
      }, null, -1),
      _createElementVNode("span", { class: "back-text" }, "Back", -1)
    ]))]),
    _createElementVNode("button", {
      class: "button button-next",
      onClick: $setup.onSelectNext,
      disabled: !$setup.isNextStepEnabled
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString($setup.nextStepTextButton), 1),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "next",
        src: _imports_1
      }, null, -1))
    ], 8, _hoisted_2)
  ]))
}